/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchEntryOverrideRestrictionDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'overrideLimit',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'override_limit',
    ],
]);
export class PatchEntryOverrideRestrictionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchEntryOverrideRestrictionDataParser.decode(input).map(res => new PatchEntryOverrideRestrictionData(res));
    }
    static unsafeDecode(input) {
        return PatchEntryOverrideRestrictionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchEntryOverrideRestrictionDataParser.encode(data);
    }
    static schema() {
        return PatchEntryOverrideRestrictionDataParser.schema();
    }
}
